
<template>
  <div class="usability">
    <img class="usability-banner" :src="bannerimg" @click="handleClickBanner" />
    <div class="usability-content">
      <div class="usability-content-left">
          <div class="usability-content-title">{{Udata[activeIndex].title}}</div>
          <div class="usability-content-text">
            <div class="usability-content-text-title">目标</div>
            <div class="usability-content-text-list" v-for="(item,index) in Udata[activeIndex].content" :key="index">{{item}}</div>
          </div>
          <div class="usability-content-text" v-if="Udata[activeIndex].cards">
            <div class="usability-content-text-title">操作指引</div>
            <div class="usability-content-text-cards"><Card  v-for="(item,index) in Udata[activeIndex].cards" :key="index" :cardInfor="item"/></div>
          </div>
          <div class="usability-content-text" v-if="Udata[activeIndex].download">
            <div class="usability-content-text-title"><span>相关资源</span> <img :src="downloadUrl" /></div>

            <a class="usability-content-text-download"  download v-for="(item,index) in Udata[activeIndex].download" @click="downloadFile(item.sourceFile)" :key="index">{{(index + 1 ) + '.' + item.title}}<br></a>
          </div>
      </div>
      <div class="usability-content-right">
        <ul>
          <li id="li_1"  :class="{active: activeIndex.split('_')[1] === '1'}"  @click="handleClick">01 测试准备</li>
          <ul id="ul_1" :class="{active: activeIndex.split('_')[1] === '1'}" @click="handleClick">
            <li id="ul_1_1" :class="{active: activeIndex === 'ul_1_1'}">编写测试计划</li>
            <li id="ul_1_2" :class="{active: activeIndex === 'ul_1_2'}" >招募用户</li>
            <li id="ul_1_3" :class="{active: activeIndex === 'ul_1_3'}">物料准备</li>
          </ul>
          <li id="li_2" :class="{active: activeIndex.split('_')[1] === '2'}"  @click="handleClick">02 测试中</li>
          <ul id="ul_2" :class="{active: activeIndex.split('_')[1] === '2'}"  @click="handleClick">
            <li id="ul_2_1" :class="{active: activeIndex === 'ul_2_1'}">暖场</li>
            <li id="ul_2_2" :class="{active: activeIndex === 'ul_2_2'}">任务测试</li>
            <li id="ul_2_3" :class="{active: activeIndex === 'ul_2_3'}">任务评价</li>
            <li id="ul_2_4" :class="{active: activeIndex === 'ul_2_4'}">测试后评分</li>
            <li id="ul_2_5" :class="{active: activeIndex === 'ul_2_5'}">致谢&结束</li>
          </ul>
          <li id="li_3" :class="{active: activeIndex.split('_')[1] === '3'}"  @click="handleClick">03 测试后</li>
          <ul id="ul_3" :class="{active: activeIndex.split('_')[1] === '3'}"  @click="handleClick">
            <li id="ul_3_1" :class="{active: activeIndex === 'ul_3_1'}">数据分析&结果报告</li>
          </ul>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import Axios from '@/assets/js/ajax'
import {Udata} from '@/assets/js/usability.js'
import BannerImg1 from "@/assets/img/usability/banner1.png";
import download from "@/assets/img/usability/download.png";
import Card from '@/components/usablility/Card'
export default {
  name: "Base",
  data() {
    return {
      bannerimg: BannerImg1,
      activeIndex: "ul_1_1",
      downloadUrl: download,
      Udata
    };
  },
  components: {Card},
  computed: {},
  created() {},
  methods: {
      handleClick (event) {       
       if(event.srcElement.tagName !== 'LI' ) return
        this.activeIndex = event.srcElement.id.split('_').length > 2 ? event.srcElement.id : event.srcElement.id.replace('li','ul') + '_1'
      },
      handleClickBanner () {
        window.open(`https://ueclub.kingdee.com/p/6344c90aeaae8200234d4627`)
      },
      async downloadFile(sourceFile) {
       let {data} = await Axios.get(`https://ueclub.kingdee.com/api/downloadPrivate?id=1003696789016293376`);
       window.open(data.data)
    },
  },
};
</script>
<style lang="scss">
.usability {
  .usability-banner {
    width: 100%;
    border-radius: 6px;
    &:hover{
      cursor: pointer;
    }
  }
  .usability-content {
    display: flex;
    margin-top: 35px;
    justify-content: space-between;
    min-height: 714px;
    .usability-content-left {
      text-align: left;
      width: calc(100% - 313px);
      .usability-content-title {
        font-size: 24px;
        color: #333333;
        letter-spacing: 0;
        font-weight: 700;
        margin-bottom: 40px;
      }
      .usability-content-text {
        margin-bottom: 60px;
        .usability-content-text-title {
          font-size: 16px;
          color: #333333;
          letter-spacing: 0;
          font-weight: 700;
          line-height: 48px;
          border-bottom: 1px solid #EAEAEA;
          margin-bottom: 16px;
          display: flex;
          align-items: center;
          >img {
            width: 20px;
            margin-left: 12px;
          }
         }
         .usability-content-text-cards {
           display: flex;
           justify-content: flex-start;
           >div {
             margin-right: 30px;
           }
         }
         .usability-content-text-list {
            font-size: 16px;
            color: #333333;
            letter-spacing: 0;
            line-height: 26px;
            font-weight: 400;
           
         }
         .usability-content-text-download {
           font-size: 16px;
            color: #2BA9FF;
            letter-spacing: 0;
            line-height: 28px;
            font-weight: 400;
            &:hover {
              cursor: pointer;
            }
         }
      }
    }
    .usability-content-right {
      width: 160px;
      > ul {
        text-align: left;
        color: #666666;
        ul {
          list-style: none;
          &:hover {
            cursor: pointer;
          }
        }
        li {
          list-style: none;
          &:hover {
            cursor: pointer;
          }
        }
        > li {
          font-size: 16px;
          color: #666666;
          letter-spacing: 0;
          font-weight: 600;
          position: relative;
          padding-left: 15px;
          &::before {
            position: absolute;
            top: 2px;
            left: -6px;
            content: "";
            width: 10px;
            height: 10px;
            transform: rotate(-45deg);
            background: #dbdbdb;
          }
          &.active {
            color: #333333;
            &::before {
              background: #e70012;
            }
          }
          border-left: 2px solid #dbdbdb;
           &.active {
              border-left: 2px solid #e70012;
          }
        }
        > ul {
          padding-left: 37px;
          border-left: 2px solid #dbdbdb;
          padding-top: 16px;
          padding-bottom: 16px;
          & > :first-child {
            margin-top: 0;
          }
          & > :last-child {
            margin-bottom: 0;
          }
          &.active {
              border-left: 2px solid #e70012;
             >li{color: #333333; font-weight: 600;} 
          }
          > li {
            margin: 16px 0;
            position: relative;
            &.active {
              color:#e70012;
              &::before {
                position: absolute;
                top: 0px;
                left: -38px;
                content: "";
                width: 0px;
                height: 0px;
                border-top: 6px solid transparent;
                border-bottom: 6px solid transparent;
                border-left: 6px solid #e70012;
              }
            }
          }
        }
      }
    }
  }
}
</style>